<template lang="pug">
  v-row(justify='center')
    v-dialog(v-model='dialog', fullscreen='', hide-overlay='', transition='dialog-bottom-transition')
      template(v-slot:activator='{ on }')
        v-tooltip( right='' bottom='' v-on='on')
            template(v-slot:activator='{ on }')
              v-btn(color='primary'  rounded  v-on='on' @click='dialog=true; Ordenes_de_compra.selectedKey = ""') 
                span Agregar 
            span Añadir
      v-card
        v-toolbar(dark='', color='primary')
          v-btn(icon='', dark='', @click='dialog = false')
            v-icon fas fa-times
          v-toolbar-title Orden de compra
          .flex-grow-1
          v-toolbar-items
            v-btn(dark='', text='', @click='generar_orden_de_compra_directamente(),dialog = false') Generar 
        v-list(three-line='', subheader='')
          v-stepper(v-model='e6', vertical='')
            v-stepper-step(:complete='e6 > 1', step='1' @click='e6 = 1')
                small Lista de proveedores
            v-stepper-content(step='1' :complete='e6 > 1'  @click='e6 = 1')
                v-select( v-model="datos.proveedor" :items="registro_provedores" label="Seleccione el proveedor" return-object item-text='name' chips  )
                v-text-field(v-model='datos.correo_adicional' label='Correo adicional')
                v-btn(color='primary', @click='e6 = 2') Continuar
                v-btn(text='') Cancelar
            v-stepper-step(:complete='e6 > 2', step='2'  @click='e6 = 2') 
                small Selecciona los productos
            v-stepper-content(step='2' :complete='e6 > 2')
                small A continuación indique el precio(Inc. IGV) de los elementos, luego de seleccionarlos. 
                v-layout
                    v-combobox(v-model='items' :items='registro_productos' :item-text='item=>`${item.descripcion} ${item.presentacion}`' label='Productos' return-object @change='agregar_productos(items)')
                v-data-table(:headers='encabezado' :items='Ordenes_de_compra.datos.items' )
                    template( v-slot:item.cantidad='{item}')
                        v-text-field( type='number' required v-model.number='item.cantidad' )
                    template( v-slot:item.valor_unitario='{item}')
                        v-text-field( type='number' required v-model.number='item.valor_unitario')
                    template( v-slot:item.tipo_de_igv='{item}')
                        v-btn(v-model='item.tipo_de_igv' outlined color='primary' @click='item.tipo_de_igv = item.tipo_de_igv === 1 ? 8 : 1')
                            span {{ item.igv | number }} 
                            v-icon(small v-if='item.tipo_de_igv === 8') fas fa-plus
                    template( v-slot:item.descuento='{item}')
                        v-text-field( type='number' required v-model.number='item.descuento' )
                        span( :v-html='item.igv = toNumber((item.tipo_de_igv === 1) ? item.valor_unitario * 0.18 * item.cantidad : 0)'  )
                        span( :v-html='item.precio_unitario = toNumber((item.tipo_de_igv === 1) ? item.valor_unitario * 1.18 : item.valor_unitario)' )
                        span( :v-html='item.subtotal = toNumber(item.cantidad * item.valor_unitario - item.descuento) ' v-show='false' )
                        span( :v-html='item.total = toNumber((item.tipo_de_igv === 1) ? ( item.cantidad * item.valor_unitario - item.descuento ) * 1.18 : item.cantidad * item.valor_unitario - item.descuento) ' v-show='false' )
                    template(v-slot:item.action='props')
                        v-btn(@click='eliminar_productos(props.item)' icon)
                            v-icon(color='primary' small ) far fa-trash-alt
                v-btn(color='primary', @click='e6 = 3') Continuar
                v-btn(text='') Cancelar
            v-stepper-step(:complete='e6 > 3', step='3'  @click='e6 = 3') 
                small Calidad
            v-stepper-content(step='3' :complete='e6 > 3')
                v-text-field(v-model='datos.calidad' label='Certificación de Calidad')
                v-text-field( v-model='datos.garantia'  label='Especificar garantía')
                v-btn(color='primary', @click='e6 = 4'  ) Continuar
                v-btn(text='') Cancelar
            v-stepper-step(step='4' :complete='e6 > 4' @click='e6 = 4') 
                small Condiciones de pago
            v-stepper-content(step='4')
                v-select( v-model ='datos.medio_de_pago' :items='Medio_de_pago_record' item-text='description' item-value= 'description' return-object label='Medio de pago'  )
                v-text-field( label='Condición de pago: Especificar días de crédito ( 0 para contado )' v-model.Number='datos.condiciones_de_pago' type='number')
                v-select( v-model='datos.tipo_de_cambio' :items='lista_de_monedas' item-text='label' item-value='value' label='Moneda' )
                v-btn(color='primary', @click='e6 = 5') Continuar
                v-btn(text='') Cancelar
            v-stepper-step(:complete='e6 > 5' step='5' @click='e6 = 5') 
                small Observaciones
            v-stepper-content(step='5') 
                v-container
                    v-col
                        v-row
                            v-switch(v-model='datos.envalaje' label='¿El producto será correctamente envalado?' class='ma-2')
                        v-row
                            v-switch(v-model='datos.envio' label='¿Incluye envío?' class='ma-2')
                        v-row
                            v-text-field(v-model='datos.Observaciones' label='Observaciones')
</template>
<script>
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
import lista_de_monedas from '@/jsons/tipo_monedas.json'
export default {
  data:()=>({
    items: '',

      dialog: false,
      e6: 1,
       encabezado: [
      {text: 'Descripcion', value: 'descripcion'},
      {text: 'Presentación', value: 'presentacion'},
      {text: 'Cantidad', value: 'cantidad'},
      { text: 'Valor U.', value: 'valor_unitario' },
      { text: 'IGV', value: 'tipo_de_igv'},
      { text: 'Descuento (S/)', value: 'descuento'},
      { text: 'SubTotal', value: 'subtotal'},
      { text: 'Total', value: 'total'},
      {text: '', value: 'action'},
    ],
    lista_de_monedas,
  }),
  methods: {
      ...mapActions({
          generar_orden_de_compra_directamente: 'Ordenes_de_compra/generar_orden_de_compra_directamente',
      }),
       agregar_productos(items){
          if (items) this.Ordenes_de_compra.datos.items.push({...items, tipo_de_igv : 1})
          this.items = ''
      },
      eliminar_productos(items){
        this.datos.items.splice( this.datos.items.indexOf(items), 1)    
      },  
    },
    computed: {
      ...mapGetters({
        Medio_de_pago_record: 'PaymentMethods/record',
        registro_provedores: 'Suppliers/record',
        registro_productos: 'Product/record',
      }),
       ...mapState({
      datos: state=> state.Ordenes_de_compra.datos,
      Ordenes_de_compra:state =>state.Ordenes_de_compra,
    })
  },  
}
</script>